import { ActionTypes } from "../../constants/ActionTypes";

const INIT_STATE = {
    // v1 <==
    loading: true,
    disableSendFileInChat: true,
    uploadModel: null,
    imgUrls: [],
    // v2 <==
    userRooms: [],
    selectedRoom: null,
    searchRooms: [],
    userInfo: null,
    conversations: [],
    newMsgCallback: null,
    unDeliveredIs: [],
    unReadIds: [],
    userRoomsWithNewMessage: [],
    userRoomsDetailWithNewMessage: [],
    signalRIsDisconnected: false,
};

export default (state = INIT_STATE, action: any) => {
    switch (action.type) {
        // v1 <==
        case ActionTypes.GET_DISABLE_SEND_FILE_IN_CHAT: {
            return {
                ...state,
            };
        }

        case ActionTypes.FETCH_DISABLE_SEND_FILE_IN_CHAT_SUCCESS: {
            return {
                ...state,
                disableSendFileInChat: action.payload,
            };
        }

        case ActionTypes.CHAT_FILE_UPLOAD: {
            return {
                ...state,
                uploadModel: action.payload,
            };
        }

        case ActionTypes.CHAT_FILE_UPLOAD_SUCCESS: {
            return {
                ...state,
            };
        }

        case ActionTypes.ADD_CHAT_IMG_URL: {
            let item = action.payload as never;
            let clone = [...state.imgUrls, item];
            return {
                ...state,
                imgUrls: clone,
            };
        }

        case ActionTypes.CLEAR_CHAT_IMG_URL: {
            return {
                ...state,
                imgUrls: [],
            };
        }

        // v2 <==
        case ActionTypes.GET_USER_ROOMS: {
            return {
                ...state,
                userRooms: [],
            };
        }

        case ActionTypes.FETCH_USER_ROOMS_SUCCESS: {
            return {
                ...state,
                userRooms: action.payload,
            };
        }

        case ActionTypes.SELECT_ROOM: {
            let room = action.payload;

            let userRoomsDetailWithNewMessageClone = [
                ...state.userRoomsDetailWithNewMessage,
            ];
            let userRoomsWithNewMessageClone = [...state.userRoomsWithNewMessage];
            let targetUserRoomsDetailWithNewMessage;
            let targetUserRoomsWithNewMessage;
            if (room && room.Id) {
                targetUserRoomsDetailWithNewMessage =
                    userRoomsDetailWithNewMessageClone.filter(
                        (item: any) => item.Id !== room.Id
                    );
                targetUserRoomsWithNewMessage = userRoomsWithNewMessageClone.filter(
                    (item: any) => item !== room.Id
                );
                // userRoomsWithNewMessage
            } else {
                targetUserRoomsDetailWithNewMessage =
                    userRoomsDetailWithNewMessageClone;
                targetUserRoomsWithNewMessage = userRoomsWithNewMessageClone;
            }

            return {
                ...state,
                selectedRoom: room,
                userRoomsDetailWithNewMessage: targetUserRoomsDetailWithNewMessage,
                userRoomsWithNewMessage: targetUserRoomsWithNewMessage,
            };
        }

        // case ActionTypes.GET_NEW_ROOM_MESSAGES: {
        //     return {
        //         ...state,
        //         conversations: [],
        //     };
        // }

        case ActionTypes.FETCH_NEW_ROOM_MESSAGES_SUCCESS: {

            let { roomId } = action.payload;

            let userRooms = [...state.userRooms];

            let oldList = state.conversations;
            let newList = action.payload.list;

            let targetList = [...oldList, ...newList];

            let ids = [...targetList.map((msg: any) => msg.Id)];

            let minId = Math.min(...ids);
            let maxId = Math.max(...ids);

            userRooms.map((item: any) => {
                if (item.Id === roomId) {
                    item.MinId = minId;
                    item.MaxId = maxId;
                }
                return item;
            });

            let unReadIdsClone = [...state.unReadIds] as any;

            newList.map((item: any) => {
                if (item.UnRead) {
                    unReadIdsClone = [...unReadIdsClone, item.Id];
                }
            });


            let resArr = [] as any;

            targetList.forEach(function (item) {
                var i = resArr.findIndex((x: any) => x.Id == item.Id);
                if (i <= -1) {
                    resArr.push({
                        Id: item.Id,
                        ContentType: item.ContentType,
                        MessageText: item.MessageText,
                        RoomId: item.RoomId,
                        SendDateTime: item.SendDateTime,
                        SendDateTimeStandard: item.SendDateTimeStandard,
                        SenderEmployeeId: item.SenderEmployeeId,
                        SenderName: item.SenderName,
                        UnDelivered: item.UnDelivered,
                        UnRead: item.UnRead,
                    });
                }
            });


            return {
                ...state,
                userRooms: userRooms,
                conversations: resArr,
                unReadIds: [...new Set(unReadIdsClone)],
            };
        }

        case ActionTypes.GET_OLD_ROOM_MESSAGES: {
            return {
                ...state,
                conversations: [],
            };
        }

        case ActionTypes.CLEAR_CONVERSATIONS_MESSAGES: {
            return {
                ...state,
                conversations: [],
            };
        }

        case ActionTypes.FETCH_OLD_ROOM_MESSAGES_SUCCESS: {
            let { roomId, list } = action.payload;

            let userRooms = [...state.userRooms];
            let ids = [...list.map((msg: any) => msg.Id)];

            let minId = Math.min(...ids);
            let maxId = Math.max(...ids);

            userRooms.map((item: any) => {
                if (item.Id === roomId) {
                    item.MinId = minId;
                    item.MaxId = maxId;
                }
                return item;
            });

            let unReadIdsClone = [...state.unReadIds] as any;

            list.map((item: any) => {
                if (item.UnRead) {
                    unReadIdsClone = [...unReadIdsClone, item.Id];
                }
            });

            return {
                ...state,
                userRooms: userRooms,
                conversations: list.reverse(),
                unReadIds: [...new Set(unReadIdsClone)],
                signalRIsDisconnected: false,
            };
        }

        case ActionTypes.SEARCH_ROOMS: {
            return {
                ...state,
                searchRooms: [],
            };
        }

        case ActionTypes.SEARCH_ROOMS_SUCCESS: {
            return {
                ...state,
                searchRooms: action.payload,
            };
        }

        case ActionTypes.GET_USER_INFO: {
            return {
                ...state,
                userInfo: null,
            };
        }

        case ActionTypes.GET_USER_INFO_SUCCESS: {
            return {
                ...state,
                userInfo: action.payload,
            };
        }

        case ActionTypes.SEND_TEXT_MESSAGE_SUCCESS: {
            let newconversations = [...state.conversations, action.payload];

            return {
                ...state,
                conversations: newconversations,
            };
        }

        case ActionTypes.NOTIFY_NEW_MESSAGE: {
            // اگر پیام جدید برای
            // selectedRoom
            // نبود باید کاربری که این پیام از طرف اون هستش به
            // userRoomsWithNewMessage
            // اضافه شود

            if (!action.payload) return state;

            let { selectedRoom } = state as any;
            let target = [] as any;
            let roomId = action.payload.RoomId;

            if (selectedRoom) {
                if (selectedRoom.Id !== roomId) {
                    target = [...state.userRoomsWithNewMessage, roomId];
                }
            } else {
                target = [...state.userRoomsWithNewMessage, roomId];
            }

            return {
                ...state,
                newMsgCallback: action.payload,
                userRoomsWithNewMessage: [...new Set(target)]
            };
        }

        case ActionTypes.ADD_NEW_ROOM_SUCCESS: {
            let newUserRooms = [...state.userRooms, action.payload];

            return {
                ...state,
                userRooms: newUserRooms,
            };
        }

        case ActionTypes.CLEAR_UNREAD_IDS: {
            let unReadIdsClone = [...state.unReadIds];

            let newUnReadIds = unReadIdsClone.filter(
                (item) => !action.payload.includes(item)
            );

            return {
                ...state,
                unReadIds: newUnReadIds,
            };
        }

        case ActionTypes.GET_USER_ROOMS_WITH_NEW_MESSAGE_SUCCESS: {
            return {
                ...state,
                userRoomsWithNewMessage: action.payload,
            };
        }

        case ActionTypes.GET_USER_ROOMS_DETAIL_WITH_NEW_MESSAGE_SUCCESS: {
            let clone = [...state.userRoomsDetailWithNewMessage, action.payload];

            return {
                ...state,
                userRoomsDetailWithNewMessage: clone,
            };
        }

        case ActionTypes.IS_DISCONNECTED: {

            return {
                ...state,
                signalRIsDisconnected: true,
            };
        }

        default:
            return state;
    }
};
